import React, { useState } from "react";
import { Header } from "../Header";
import { Layout } from "./Layout";
import { Link } from "react-router-dom";
import { Sidebar } from "../Sidebar";

export const Plstatement = () => {
  const [isSidebar, setSidebar] = useState(false);
  return (
    <>
      {isSidebar && <Sidebar />}
      <Header isSidebar={isSidebar} setSidebar={setSidebar} />
      <div
        _ngcontent-hdd-c80=""
        className="bg-white"
      >
        <div className="marquee">
          <marquee>
            Betfair exchange odds are under maintenance Bookmaker and Fancy odds
            are available to play.
          </marquee>
        </div>
        <app-reports _nghost-hdd-c162="" className="ng-star-inserted">
          <div _ngcontent-hdd-c162="" className="pcoded-main-container bg-white">
            <div
              _ngcontent-hdd-c162=""
              className="container-fluid pl-3 accounts-box"
            >
              <div _ngcontent-hdd-c162="" className="row account-tabs">
                <Layout />
                <div
                  _ngcontent-oqs-c169=""
                  className="col-12 mt-2 px-1 centralized_css"
                >
                  <app-results _nghost-dml-c163="" className="ng-star-inserted">
                    <div _ngcontent-dml-c163="" className="right-tab-box">
                      <div
                        _ngcontent-dml-c163=""
                        id="v-pills-tabContent"
                        className="tab-content"
                      >
                        <div
                          _ngcontent-dml-c163=""
                          id="v-pills-results"
                          role="tabpanel"
                          aria-labelledby="v-pills-results-tab"
                          className="tab-pane show active acc-stat-box"
                        >
                          <app-reports-input
                            _ngcontent-dml-c163=""
                            _nghost-dml-c153=""
                          >
                            <form
                              _ngcontent-dml-c153=""
                              noValidate=""
                              className="ng-untouched ng-pristine ng-valid"
                            >
                              <div _ngcontent-dml-c153="" className="row">
                                <div
                                  _ngcontent-dml-c153=""
                                  className="col-md-5"
                                >
                                  <label
                                    _ngcontent-dml-c153=""
                                    htmlFor="end-date-account-statement"
                                    className="date-label"
                                  >
                                    Start Date
                                  </label>
                                  <input
                                    _ngcontent-dml-c153=""
                                    type="datetime-local"
                                    formcontrolname="endDate"
                                    className="form-control date-input ng-untouched ng-pristine ng-valid"
                                  />
                                </div>
                                <div
                                  _ngcontent-dml-c153=""
                                  className="col-md-5"
                                >
                                  <label
                                    _ngcontent-dml-c153=""
                                    htmlFor="end-date-account-statement"
                                    className="date-label"
                                  >
                                    End Date
                                  </label>
                                  <input
                                    _ngcontent-dml-c153=""
                                    type="datetime-local"
                                    formcontrolname="endDate"
                                    className="form-control date-input ng-untouched ng-pristine ng-valid"
                                  />
                                </div>
                                <div
                                  _ngcontent-dml-c153=""
                                  className="col-md-2 btn-box"
                                >
                                  <button
                                    _ngcontent-dml-c153=""
                                    type="submit"
                                    formNoValidate=""
                                  >
                                    {" "}
                                    Load Report{" "}
                                  </button>
                                </div>
                              </div>
                            </form>
                          </app-reports-input>
                          <div
                            _ngcontent-dml-c163=""
                            className="text-center pb-2 ng-star-inserted"
                          >
                            <b _ngcontent-dml-c163="">No Data Found.</b>
                          </div>
                          <div
                            _ngcontent-dml-c163=""
                            className="search-table results-table d-none"
                          >
                            <div
                              _ngcontent-dml-c163=""
                              className="table-box no-more-tables"
                            >
                              <table
                                _ngcontent-dml-c163=""
                                className="table-borderless"
                              >
                                <thead _ngcontent-dml-c163="">
                                  <th
                                    _ngcontent-dml-c163=""
                                    className="text-left"
                                  >
                                    Competition Name
                                  </th>
                                  <th
                                    _ngcontent-dml-c163=""
                                    className="text-left"
                                  >
                                    Event Name
                                  </th>
                                  <th
                                    _ngcontent-dml-c163=""
                                    className="text-left"
                                  >
                                    Market Name
                                  </th>
                                  <th
                                    _ngcontent-dml-c163=""
                                    className="text-left"
                                  >
                                    Results
                                  </th>
                                </thead>
                                <tbody _ngcontent-dml-c163=""></tbody>
                              </table>
                              <pagination-controls
                                _ngcontent-dml-c163=""
                                id="results"
                                aria-label="Default pagination"
                                className="d-flex justify-content-center paginate ng-star-inserted"
                              >
                                <pagination-template>
                                  <ul
                                    className="ngx-pagination ng-star-inserted"
                                    aria-label="Pagination"
                                  >
                                    <li className="pagination-previous disabled ng-star-inserted">
                                      <span className="ng-star-inserted">
                                        {" "}
                                        Previous{" "}
                                        <span className="show-for-sr">
                                          page
                                        </span>
                                      </span>
                                    </li>
                                    <li className="small-screen"> 1 / 11 </li>
                                    <li className="current ng-star-inserted">
                                      <span className="show-for-sr ng-star-inserted">
                                        You're on page{" "}
                                      </span>
                                      <span className="ng-star-inserted">
                                        1
                                      </span>
                                    </li>
                                    <li className="ng-star-inserted">
                                      <Link
                                        tabIndex="0"
                                        className="ng-star-inserted"
                                      >
                                        <span className="show-for-sr">
                                          page{" "}
                                        </span>
                                        <span>2</span>
                                      </Link>
                                    </li>
                                    <li className="ng-star-inserted">
                                      <Link
                                        tabIndex="0"
                                        className="ng-star-inserted"
                                      >
                                        <span className="show-for-sr">
                                          page{" "}
                                        </span>
                                        <span>3</span>
                                      </Link>
                                    </li>
                                    <li className="ng-star-inserted">
                                      <Link
                                        tabIndex="0"
                                        className="ng-star-inserted"
                                      >
                                        <span className="show-for-sr">
                                          page{" "}
                                        </span>
                                        <span>4</span>
                                      </Link>
                                    </li>
                                    <li className="ng-star-inserted">
                                      <Link
                                        tabIndex="0"
                                        className="ng-star-inserted"
                                      >
                                        <span className="show-for-sr">
                                          page{" "}
                                        </span>
                                        <span>5</span>
                                      </Link>
                                    </li>
                                    <li className="ellipsis ng-star-inserted">
                                      <Link
                                        tabIndex="0"
                                        className="ng-star-inserted"
                                      >
                                        <span className="show-for-sr">
                                          page
                                        </span>
                                        <span>...</span>
                                      </Link>
                                    </li>
                                    <li className="ng-star-inserted">
                                      <Link
                                        tabIndex="0"
                                        className="ng-star-inserted"
                                      >
                                        <span className="show-for-sr">
                                          page{" "}
                                        </span>
                                        <span>11</span>
                                      </Link>
                                    </li>

                                    <li className="pagination-next ng-star-inserted">
                                      <Link
                                        tabIndex="0"
                                        aria-label="Next page"
                                        className="ng-star-inserted"
                                      >
                                        {" "}
                                        Next{" "}
                                        <span className="show-for-sr">
                                          page
                                        </span>
                                      </Link>
                                    </li>
                                  </ul>
                                </pagination-template>
                              </pagination-controls>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </app-results>
                </div>
              </div>
            </div>
          </div>
        </app-reports>
      </div>
    </>
  );
};
